"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventQueue = exports.EventTypes = void 0;
const Request_1 = require("./Request");
const utils_1 = require("./utils");
exports.EventTypes = {
    variableEvaluated: 'variableEvaluated',
    variableDefaulted: 'variableDefaulted'
};
class EventQueue {
    constructor(sdkKey, dvcClient, eventFlushIntervalMS) {
        this.sdkKey = sdkKey;
        this.client = dvcClient;
        this.eventQueue = [];
        this.aggregateEventMap = {};
        this.eventFlushIntervalMS = eventFlushIntervalMS || 10 * 1000;
        this.flushInterval = setInterval(this.flushEvents.bind(this), this.eventFlushIntervalMS);
    }
    async flushEvents() {
        const eventsToFlush = [...this.eventQueue];
        const aggregateEventsToFlush = this.eventsFromAggregateEventMap();
        eventsToFlush.push(...aggregateEventsToFlush);
        if (!eventsToFlush.length) {
            return;
        }
        this.client.logger.info(`DVC Flush ${eventsToFlush.length} Events`);
        this.eventQueue = [];
        this.aggregateEventMap = {};
        try {
            const res = await (0, Request_1.publishEvents)(this.sdkKey, this.client.config || null, this.client.user, eventsToFlush, this.client.logger);
            if (res.status !== 201) {
                this.eventQueue.push(...eventsToFlush);
            }
            else {
                this.client.logger.info(`DVC Flushed ${eventsToFlush.length} Events.`);
            }
        }
        catch (ex) {
            this.client.eventEmitter.emitError(ex);
            this.eventQueue.push(...eventsToFlush);
        }
    }
    /**
     * Queue DVCAPIEvent for producing
     */
    queueEvent(event) {
        this.eventQueue.push(event);
    }
    /**
     * Queue DVCEvent that can be aggregated together, where multiple calls are aggregated
     * by incrementing the 'value' field.
     */
    queueAggregateEvent(event) {
        (0, utils_1.checkParamDefined)('type', event.type);
        (0, utils_1.checkParamDefined)('target', event.target);
        event.date = Date.now();
        event.value = 1;
        const aggEventType = this.aggregateEventMap[event.type];
        if (!aggEventType) {
            this.aggregateEventMap[event.type] = { [event.target]: event };
        }
        else if (aggEventType[event.target]) {
            aggEventType[event.target].value++;
        }
        else {
            aggEventType[event.target] = event;
        }
    }
    /**
     * Turn the Aggregate Event Map into an Array of DVCAPIEvent objects for publishing.
     */
    eventsFromAggregateEventMap() {
        return Object.values(this.aggregateEventMap).map((typeMap) => Object.values(typeMap)).flat();
    }
    async close() {
        clearInterval(this.flushInterval);
        await this.flushEvents();
    }
}
exports.EventQueue = EventQueue;
//# sourceMappingURL=EventQueue.js.map